import React, { useState, useEffect } from "react";
// import EmailConfirmationForm from "../AccountPage/EmailConfirmationForm";
import Alert from "../Alert/Alert";
import { EyeIcon, EyeOffIcon } from 'lucide-react';

const ResetPwForm = ({ setModalTitle, emailInitialValue = "", emailInputIsVisable = true, onSuccess }) => {
    if (setModalTitle) setModalTitle("Восстановление пароля");

    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('error');
    const [emailSubmitFormVisable, setEmailSubmitFormVisable] = useState(true);
    const [isLoading, setLoading] = useState(false);

    const [error, setError] = useState("");
    const [confirmationCode, setConfirmationCode] = useState("");

    const [email, setEmail] = useState(emailInitialValue);
    // const [showCodeInput, setShowCodeInput] = useState(false); // Показывать ли поле ввода кода
    const [emailConfirmationFormVisable, setEmailConfirmationFormVisable] = useState(false);
    const [passwordFormVisable, setPasswordFormVisable] = useState(false);

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    // const [showPwForm, setShowPwForm] = useState(false);
    // <EmailConfirmationForm handleSendCode={handleResetPw} confirmationCode={resetPwCode} setConfirmationCode={setResetPwCode} sendCodeButtonText={`Отправить код`} error={codeError} sendCodeData={{ confirmationMethod: "/Authorization/RecoverByEmail", body: JSON.stringify({ email }) }} />
    const [cooldown, setCooldown] = useState(0); // Таймер перед повторной отправкой
    useEffect(() => {
        if (cooldown > 0) {
            const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [cooldown]);


    const handleSendCode = async (e) => {
        e.preventDefault();
        if (cooldown > 0) return; // Блокируем повторный запрос, пока идет таймер
        setLoading(true);
        try {
            const response = await fetch("/Authorization/RecoverByEmail", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email })
            });
            const data = await response.json();

            if (data.success) {
                setError("");
                setEmailSubmitFormVisable(false);
                setEmailConfirmationFormVisable(true);
                setCooldown(data.nextSendCooldown);
            } else {
                setError(data.message || "Произошла ошибка")
                setAlertMessage(data.message || "Произошла ошибка");
                setAlertType('error');
                setAlertVisible(true);
                setTimeout(() => {
                    setAlertVisible(false);
                }, 3000);
            }
        } catch (err) {
            setError("Ошибка сети");
            setAlertMessage("Ошибка сети");
            setAlertType('error');
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 3000);
            // setError("Ошибка сети");
        }
        setLoading(false);
    };

    const handleSubmitEmailAndCode = async (e) => {
        e.preventDefault();
        if (!confirmationCode) return setError("Введите код подтверждения");

        setLoading(true);

        try {
            const response = await fetch("/Authorization/RecoverByEmailWithCode", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, code: confirmationCode })
            });
            const data = await response.json();

            if (data.success) {
                setError("");
                setEmailConfirmationFormVisable(false);
                setPasswordFormVisable(true);
            } else {
                setError(data.message || "Произошла ошибка")
                setAlertMessage(data.message || "Произошла ошибка");
                setAlertType('error');
                setAlertVisible(true);
                setTimeout(() => {
                    setAlertVisible(false);
                }, 3000);
            }
        } catch (err) {
            setError("Ошибка сети");
            setAlertMessage("Ошибка сети");
            setAlertType('error');
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 3000);
            // setError("Ошибка сети");
        }
        setLoading(false);
    };

    const handlePwSubmit = async (e) => {
        e.preventDefault();
        if (!newPassword || !confirmPassword) {
            setError("Заполните все поля");
            return;
        }
        if (newPassword !== confirmPassword) {
            setError("Пароли не совпадают");
            return;
        }
        setLoading(true);

        try {
            const response = await fetch("/Authorization/RecoverPassword", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, code: confirmationCode, password: newPassword })
            });
            const data = await response.json();

            if (data.success) {
                setError("");
                setPasswordFormVisable(false);
                // if (setIsOpen) setIsOpen(false);
                if (onSuccess) onSuccess();
                setAlertMessage("Пароль успешно изменён, вы можете авторизоваться с новыми данными");
                setAlertType('success');
                setAlertVisible(true);
                setTimeout(() => {
                    setAlertVisible(false);
                }, 3000);
            } else {
                setError(data.message || "Произошла ошибка")
                setAlertMessage(data.message || "Произошла ошибка");
                setAlertType('error');
                setAlertVisible(true);
                setTimeout(() => {
                    setAlertVisible(false);
                }, 3000);
            }
        } catch (err) {
            setError("Ошибка сети");
            setAlertMessage("Ошибка сети");
            setAlertType('error');
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 3000);
            // setError("Ошибка сети");
        }
        setLoading(false);
    };

    return <>
        {alertVisible && (
            <Alert
                message={alertMessage}
                type={alertType}
                onClose={() => setAlertVisible(false)}
            />
        )}
        {emailSubmitFormVisable && <form onSubmit={handleSendCode}>
            <div className="text-left px-4 py-4 rounded-md">
                {"Для сброса пароля мы отправим код на ваш email. Будьте внимательны, все сеансы будут завершены."}
            </div>
            <div className="rounded-md mb-2 p-2 flex items-center gap-2 justify-left">
                {emailInputIsVisable &&
                    <>
                        <input
                            type="email"
                            placeholder="Email"
                            className="border px-1 py-2 rounded-md w-70"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </>}
                <button className="border px-2 py-2 rounded-md w-30" disabled={isLoading}>
                    {isLoading ? "Загрузка..." : "Отправить"}
                </button>
            </div>
        </form>}
        {emailConfirmationFormVisable &&
            <>
                <form className="grid-cols-1" onSubmit={handleSubmitEmailAndCode}>
                    Код отправлен на вашу почту
                    <div className="flex items-stretch gap-2 rounded-lg text-center mt-6 mb-2">
                        <input
                            type="text"
                            value={confirmationCode}
                            onChange={(e) => setConfirmationCode(e.target.value)}
                            placeholder="Введите код"
                            className="border rounded p-2 min-w-10"
                        />

                        <button onClick={handleSendCode} className="border px-2 py-1 rounded-md" disabled={cooldown > 0}>
                            {cooldown > 0 ? `Отправить код (${cooldown}с)` : "Отправить код"}
                        </button>
                        {/* {showCodeInput &&
                sendCodeButtonNeeded &&
                <>
                    <button onClick={handleConfirmCode} className="bg-black text-white px-4 py-2 rounded-md w-full mt-2">
                        {loading ? "Загрузка..." : "Подтвердить email"}
                    </button>
                </>
                
                } */}
                    </div>
                    {error && <p className="text-red-600 text-sm">{error}</p>}
                    <button className="border px-2 py-2 rounded-md mb-2" disabled={isLoading}>
                        {isLoading ? "Загрузка..." : "Установить новый пароль"}
                    </button>
                </form>
            </>

        }
        {passwordFormVisable &&
            <form onSubmit={handlePwSubmit}>
                <div className="space-y-4 mb-2">
                    <div className="relative">
                        <input
                            type={showNewPassword ? "text" : "password"}
                            name="password"
                            placeholder="Новый пароль"
                            className="border rounded p-2 w-full"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            className="absolute right-3 top-3 text-gray-600"
                        >
                            {showNewPassword ? <EyeOffIcon /> : <EyeIcon />}
                        </button>
                    </div>

                </div>
                <div className='space-y-4 mb-2'>
                    <div className="relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Подтвердите пароль"
                            className="border rounded p-2 w-full"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="absolute right-3 top-3 text-gray-600"
                        >
                            {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                        </button>
                    </div>
                </div>
                {error && error.split("\n").map((err, index) => (
                    <p key={index} className="text-red-600 text-sm">
                        {err}
                    </p>
                ))}
                <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-black text-white px-4 py-2 rounded-md w-1/2"
                >
                    {isLoading ? "Загрузка..." : "Установить пароль"}
                </button>

            </form>
        }

    </>
}
export default ResetPwForm;